import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NgModelGroup, NgForm } from '@angular/forms';
import { HttpResponseMessage } from './models/models';

@Injectable({
  providedIn: 'root'
})
export class APIResponseHandlerService {
 constructor() { }

 handle = async (promise) => {
    let { Response, Error } =await promise.then(Response => ({ Response, undefined })).catch(Error => Promise.resolve({ undefined, Error }));
    if (Response !== undefined) {
      return this.handleResponse(Response);
    }
    else {
      return this.handleError(Error);
    }
  }

  handleResponse(event: any) {
    var modifiedHttpResponse = new HttpResponseMessage();
    modifiedHttpResponse.StatusCode = event.status;
    modifiedHttpResponse.Content = event.body;
    modifiedHttpResponse.Headers = event.headers;
    if (event.headers['get'] !== undefined && event.headers.get('content-type') !== undefined && event.headers.get('content-type') !== null)
      modifiedHttpResponse.ContentType = event.headers.get('content-type');
    else
      modifiedHttpResponse.ContentType = null;
    modifiedHttpResponse.ErrorMessage = "";
    modifiedHttpResponse.StatusText = event.statusText;
    return modifiedHttpResponse;
  }

  handleError(event: any) {
    var modifiedHttpResponse = new HttpResponseMessage();
    modifiedHttpResponse.StatusCode = event.status;
    modifiedHttpResponse.Content = event.error;
    modifiedHttpResponse.Headers = event.headers;
    if (event.headers['get'] !== undefined && event.headers.get('content-type') !== undefined && event.headers.get('content-type') !== null)
      modifiedHttpResponse.ContentType = event.headers.get('content-type');
    else
      modifiedHttpResponse.ContentType = null;
    modifiedHttpResponse.ErrorMessage = event.error;
    modifiedHttpResponse.StatusText = event.statusText;
    return modifiedHttpResponse;
  }

}